import {
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
  specCenteredContent3evlhhbrk2e00 as specCenteredContent,
} from '../views/theming/buttons.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringAfter1hku067gwr5ve as substringAfter } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
} from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance } from '../views/theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../views/components/nav/AppDimensions.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var BasicButtonFormattingClass;
function BasicButtonFormatting() {
  if (BasicButtonFormattingClass === VOID) {
    class $ {
      constructor(name, theme, displayName, displayIcon, displayIconColor, enabled) {
        theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
        displayName = displayName === VOID ? null : displayName;
        displayIcon = displayIcon === VOID ? null : displayIcon;
        displayIconColor = displayIconColor === VOID ? null : displayIconColor;
        enabled = enabled === VOID ? null : enabled;
        this.og0_1 = name;
        this.pg0_1 = theme;
        this.qg0_1 = displayName;
        this.rg0_1 = displayIcon;
        this.sg0_1 = displayIconColor;
        this.tg0_1 = enabled;
      }
      i20() {
        return this.og0_1;
      }
      mba() {
        return this.pg0_1;
      }
      e90() {
        return this.qg0_1;
      }
      ug0() {
        return this.rg0_1;
      }
      vg0() {
        return this.sg0_1;
      }
      fbs() {
        return this.tg0_1;
      }
      toString() {
        return 'BasicButtonFormatting(name=' + this.og0_1 + ', theme=' + toString(this.pg0_1) + ', displayName=' + toString_0(this.qg0_1) + ', displayIcon=' + toString_0(this.rg0_1) + ', displayIconColor=' + toString_0(this.sg0_1) + ', enabled=' + toString_0(this.tg0_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.og0_1);
        result = imul(result, 31) + hashCode(this.pg0_1) | 0;
        result = imul(result, 31) + (this.qg0_1 == null ? 0 : hashCode(this.qg0_1)) | 0;
        result = imul(result, 31) + (this.rg0_1 == null ? 0 : hashCode(this.rg0_1)) | 0;
        result = imul(result, 31) + (this.sg0_1 == null ? 0 : hashCode(this.sg0_1)) | 0;
        result = imul(result, 31) + (this.tg0_1 == null ? 0 : hashCode(this.tg0_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BasicButtonFormatting()))
          return false;
        if (!(this.og0_1 === other.og0_1))
          return false;
        if (!equals(this.pg0_1, other.pg0_1))
          return false;
        if (!equals(this.qg0_1, other.qg0_1))
          return false;
        if (!equals(this.rg0_1, other.rg0_1))
          return false;
        if (!equals(this.sg0_1, other.sg0_1))
          return false;
        if (!equals(this.tg0_1, other.tg0_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'BasicButtonFormatting');
    BasicButtonFormattingClass = $;
  }
  return BasicButtonFormattingClass;
}
function ButtonFormatting(name, theme, displayName, displayIcon, displayIconColor, enabled) {
  theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
  displayName = displayName === VOID ? null : displayName;
  displayIcon = displayIcon === VOID ? null : displayIcon;
  displayIconColor = displayIconColor === VOID ? null : displayIconColor;
  enabled = enabled === VOID ? null : enabled;
  return new (BasicButtonFormatting())(name, theme, displayName, displayIcon, displayIconColor, enabled);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      wg0(name, theme, displayName, enabled, unread, action) {
        return ButtonAction().fg1(name, theme, displayName, null, null, enabled, action);
      }
      gg1(name, theme, displayName, enabled, unread, action, $super) {
        theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
        displayName = displayName === VOID ? null : displayName;
        enabled = enabled === VOID ? null : enabled;
        return $super === VOID ? this.wg0(name, theme, displayName, enabled, unread, action) : $super.wg0.call(this, name, theme, displayName, enabled, unread, action);
      }
      hg1(name, theme, displayName, enabled, actionIcon, unread, action) {
        var tmp = ($this$ButtonAction) => {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          var tmp0_safe_receiver = actionIcon($this$ButtonAction);
          return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ng1_1;
        };
        return ButtonAction().fg1(name, theme, displayName, tmp, ($this$ButtonAction) => {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          var tmp0_safe_receiver = actionIcon($this$ButtonAction);
          return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lg1_1;
        }, enabled, action);
      }
      og1(name, theme, displayName, enabled, actionIcon, unread, action, $super) {
        theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
        displayName = displayName === VOID ? null : displayName;
        enabled = enabled === VOID ? null : enabled;
        unread = unread === VOID ? null : unread;
        return $super === VOID ? this.hg1(name, theme, displayName, enabled, actionIcon, unread, action) : $super.hg1.call(this, name, theme, displayName, enabled, actionIcon, unread, action);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var ButtonActionClass;
function ButtonAction() {
  if (ButtonActionClass === VOID) {
    class $ {
      static fg1(name, theme, displayName, displayIcon, displayIconColor, enabled, action) {
        theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
        displayName = displayName === VOID ? null : displayName;
        displayIcon = displayIcon === VOID ? null : displayIcon;
        displayIconColor = displayIconColor === VOID ? null : displayIconColor;
        enabled = enabled === VOID ? null : enabled;
        var $this = createThis(this);
        $this.xg0_1 = Action(name, VOID, VOID, VOID, VOID, VOID, action);
        $this.yg0_1 = name;
        $this.zg0_1 = theme;
        $this.ag1_1 = displayName;
        $this.bg1_1 = displayIcon;
        $this.cg1_1 = displayIconColor;
        $this.dg1_1 = enabled;
        $this.eg1_1 = action;
        return $this;
      }
      i20() {
        return this.yg0_1;
      }
      mba() {
        return this.zg0_1;
      }
      e90() {
        return this.ag1_1;
      }
      ug0() {
        return this.bg1_1;
      }
      vg0() {
        return this.cg1_1;
      }
      fbs() {
        return this.dg1_1;
      }
      static pg1(format, action) {
        return this.fg1(format.i20(), format.mba(), format.e90(), format.ug0(), format.vg0(), format.fbs(), action);
      }
      qg1(name, theme, displayName, displayIcon, displayIconColor, enabled, action) {
        return ButtonAction().fg1(name, theme, displayName, displayIcon, displayIconColor, enabled, action);
      }
      rg1(name, theme, displayName, displayIcon, displayIconColor, enabled, action, $super) {
        name = name === VOID ? this.yg0_1 : name;
        theme = theme === VOID ? this.zg0_1 : theme;
        displayName = displayName === VOID ? this.ag1_1 : displayName;
        displayIcon = displayIcon === VOID ? this.bg1_1 : displayIcon;
        displayIconColor = displayIconColor === VOID ? this.cg1_1 : displayIconColor;
        enabled = enabled === VOID ? this.dg1_1 : enabled;
        action = action === VOID ? this.eg1_1 : action;
        return $super === VOID ? this.qg1(name, theme, displayName, displayIcon, displayIconColor, enabled, action) : $super.qg1.call(this, name, theme, displayName, displayIcon, displayIconColor, enabled, action);
      }
      toString() {
        return 'ButtonAction(name=' + this.yg0_1 + ', theme=' + toString(this.zg0_1) + ', displayName=' + toString_0(this.ag1_1) + ', displayIcon=' + toString_0(this.bg1_1) + ', displayIconColor=' + toString_0(this.cg1_1) + ', enabled=' + toString_0(this.dg1_1) + ', action=' + toString(this.eg1_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.yg0_1);
        result = imul(result, 31) + hashCode(this.zg0_1) | 0;
        result = imul(result, 31) + (this.ag1_1 == null ? 0 : hashCode(this.ag1_1)) | 0;
        result = imul(result, 31) + (this.bg1_1 == null ? 0 : hashCode(this.bg1_1)) | 0;
        result = imul(result, 31) + (this.cg1_1 == null ? 0 : hashCode(this.cg1_1)) | 0;
        result = imul(result, 31) + (this.dg1_1 == null ? 0 : hashCode(this.dg1_1)) | 0;
        result = imul(result, 31) + hashCode(this.eg1_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ButtonAction()))
          return false;
        if (!(this.yg0_1 === other.yg0_1))
          return false;
        if (!equals(this.zg0_1, other.zg0_1))
          return false;
        if (!equals(this.ag1_1, other.ag1_1))
          return false;
        if (!equals(this.bg1_1, other.bg1_1))
          return false;
        if (!equals(this.cg1_1, other.cg1_1))
          return false;
        if (!equals(this.dg1_1, other.dg1_1))
          return false;
        if (!equals(this.eg1_1, other.eg1_1))
          return false;
        return true;
      }
      zbe(scope) {
        this.xg0_1.zbe(scope);
      }
      wcv() {
        return this.xg0_1.wcv();
      }
      zd7() {
        return this.xg0_1.sah();
      }
      sah() {
        return this.zd7();
      }
      vah(listener) {
        return this.xg0_1.vah(listener);
      }
      kaj() {
        return this.xg0_1.kaj();
      }
    }
    initMetadataForClass($, 'ButtonAction', VOID, VOID, [Reactive()]);
    ButtonActionClass = $;
  }
  return ButtonActionClass;
}
var IconOverrideClass;
function IconOverride() {
  if (IconOverrideClass === VOID) {
    class $ {
      constructor(color) {
        this.sg1_1 = color;
      }
      hd1(theme) {
        return theme.td1('icn' + substringAfter(this.sg1_1.naz(), _Char___init__impl__6a9atx(35)), VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.sg1_1).cb1_1;
      }
      toString() {
        return 'IconOverride(color=' + this.sg1_1.toString() + ')';
      }
      hashCode() {
        return this.sg1_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IconOverride()))
          return false;
        if (!this.sg1_1.equals(other.sg1_1))
          return false;
        return true;
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, 'IconOverride', VOID, VOID, [ThemeDerivation()]);
    IconOverrideClass = $;
  }
  return IconOverrideClass;
}
function rviewFormatting(_this__u8e3s4, formatting, usingSpec) {
  usingSpec = usingSpec === VOID ? true : usingSpec;
  if (!(formatting.vg0() == null)) {
    dynamicTheme(_this__u8e3s4, ($this$dynamicTheme) => {
      var tmp0_safe_receiver = formatting.vg0();
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        tmp = tmp0_safe_receiver($this$dynamicTheme);
      }
      var color = tmp;
      return !(color == null) ? formatting.mba().abf(new (IconOverride())(color)) : formatting.mba();
    });
  } else {
    _this__u8e3s4.lba(_this__u8e3s4.qb6_1.abf(formatting.mba()));
  }
  if (usingSpec) {
    specCenteredContent(_this__u8e3s4, VOID, ($this$specCenteredContent) => rviewFormatting$contents($this$specCenteredContent, formatting, usingSpec));
  } else
    _this__u8e3s4.lbb(get_centered(_this__u8e3s4), rviewFormatting$contents(_this__u8e3s4, formatting, usingSpec));
}
function applyReactiveFormatting(_this__u8e3s4, formatting, usingSpec, withReactive) {
  usingSpec = usingSpec === VOID ? true : usingSpec;
  dynamicTheme(_this__u8e3s4, ($this$dynamicTheme) => {
    var tmp0_safe_receiver = $this$dynamicTheme.daj(formatting);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.vg0();
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        tmp_0 = tmp0_safe_receiver_0($this$dynamicTheme);
      }
      var iconColor = tmp_0;
      tmp = !(iconColor == null) ? tmp0_safe_receiver.mba().abf(new (IconOverride())(iconColor)) : tmp0_safe_receiver.mba();
    }
    return tmp;
  });
  var content = (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.gbb(p, view);
    view.zbm(false);
    var tmp = get_centered(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (IconView())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    var $this$icon = view_0;
    reactive($this$icon, ($this$reactive) => {
      var a = $this$reactive.daj(formatting);
      var tmp1_safe_receiver = a == null ? null : a.ug0();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        tmp = tmp1_safe_receiver($this$reactive);
      }
      var icon = tmp;
      $this$icon.dba(!(icon == null));
      $this$icon.sbt(icon);
      $this$icon.gbu(a == null ? null : a.i20());
      return Unit_instance;
    });
    view.hbb(p_0, view_0);
    view.lbb(tmp, view_0);
    var tmp_0 = view.kbb(!usingSpec ? get_expanding(view) : Companion_getInstance(), get_centered(view));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
    if (!usingSpec) {
      var tmp_1 = KMutableProperty0();
      var tmp_2 = TextView$_get_align_$ref_7uii4p(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('align', 0, tmp_1, tmp_2, TextView$_set_align_$ref_lgby9v(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        var tmp;
        var tmp0_safe_receiver = $this$reactiveScope.daj(formatting);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ug0();
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          tmp_0 = tmp1_safe_receiver($this$reactiveScope);
        }
        if (!(tmp_0 == null)) {
          tmp = Align_Start_getInstance();
        } else {
          tmp = Align_Center_getInstance();
        }
        var tmp$ret$8 = tmp;
        this_0.set(tmp$ret$8);
        return Unit_instance;
      });
    }
    var tmp_3 = KMutableProperty0();
    var tmp_4 = TextView$_get_content_$ref_4pzcwl(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp0_safe_receiver = $this$reactiveScope.daj(formatting);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver_0 = tmp0_safe_receiver.e90();
        var tmp_0;
        if (tmp0_safe_receiver_0 == null) {
          tmp_0 = null;
        } else {
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          tmp_0 = tmp0_safe_receiver_0($this$reactiveScope);
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp = tmp1_elvis_lhs == null ? tmp0_safe_receiver.i20() : tmp1_elvis_lhs;
      }
      var tmp1_elvis_lhs_0 = tmp;
      var tmp$ret$13 = tmp1_elvis_lhs_0 == null ? '' : tmp1_elvis_lhs_0;
      this_1.set(tmp$ret$13);
      return Unit_instance;
    });
    view.hbb(p_1, view_1);
    view.lbb(tmp_0, view_1);
    _this__u8e3s4.hbb(p, view);
    return view;
  };
  if (usingSpec)
    specCenteredContent(_this__u8e3s4, VOID, content);
  else {
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Frame())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.gbb(p, view);
    view.lbb(get_centered(view), content(view));
    _this__u8e3s4.hbb(p, view);
  }
  reactive(_this__u8e3s4, ($this$reactive) => {
    // Inline function 'kotlin.let' call
    var it = $this$reactive.daj(formatting);
    _this__u8e3s4.dba(!(it == null));
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    withReactive($this$reactive, it);
    return Unit_instance;
  });
}
function mobileButtonRow(_this__u8e3s4, formats) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  var $this$row = view;
  $this$row.bb9(get_AppDimensions().kg2_1);
  var moreThanOneButton = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp0 = formats;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (!($this$remember.daj(element) == null)) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$0 = count;
    }
    return tmp$ret$0 > 1;
  });
  reactive($this$row, ($this$reactive) => {
    $this$row.bba();
    var tmp;
    if ($this$reactive.daj(moreThanOneButton)) {
      var _iterator__ex2g4s = formats.m1();
      while (_iterator__ex2g4s.n1()) {
        var format = _iterator__ex2g4s.o1();
        var tmp_0 = get_expanding($this$row);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_0 = $this$row;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(this_0.pc());
        var tmp0_elvis_lhs = this_0.ebb_1;
        var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
        this_0.gbb(p, view);
        applyReactiveActionFormatting(view, format, false);
        this_0.hbb(p, view);
        $this$row.lbb(tmp_0, view);
      }
      tmp = Unit_instance;
    } else {
      var tmp_1 = get_expanding($this$row);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_1 = $this$row;
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (Space())(this_1.pc());
      var tmp0_elvis_lhs_0 = this_1.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? this_1 : tmp0_elvis_lhs_0;
      this_1.gbb(p_0, view_0);
      this_1.hbb(p_0, view_0);
      $this$row.lbb(tmp_1, view_0);
      var _iterator__ex2g4s_0 = formats.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var format_0 = _iterator__ex2g4s_0.o1();
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_2 = $this$row;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Button())(this_2.pc());
        var tmp0_elvis_lhs_1 = this_2.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? this_2 : tmp0_elvis_lhs_1;
        this_2.gbb(p_1, view_1);
        applyReactiveActionFormatting(view_1, format_0, true);
        this_2.hbb(p_1, view_1);
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return view;
}
function applyActionFormatting(_this__u8e3s4, action, usingSpec, expandText) {
  usingSpec = usingSpec === VOID ? true : usingSpec;
  expandText = expandText === VOID ? false : expandText;
  rviewFormatting(_this__u8e3s4, action, usingSpec);
  if (!(action.dg1_1 == null)) {
    var tmp = KMutableProperty0();
    var tmp_0 = Button$_get_enabled_$ref_61t7nx(_this__u8e3s4);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp, tmp_0, Button$_set_enabled_$ref_o8kynz(_this__u8e3s4));
    var actionToCalculate = action.dg1_1;
    reactiveScope(_this__u8e3s4, ($this$reactiveScope) => {
      this_0.set(actionToCalculate($this$reactiveScope));
      return Unit_instance;
    });
  }
  _this__u8e3s4.obg(action);
}
function applyFormatting(_this__u8e3s4, format) {
  return rviewFormatting(_this__u8e3s4, format);
}
function button(_this__u8e3s4, buttonAction, usingSpec) {
  usingSpec = usingSpec === VOID ? true : usingSpec;
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  applyActionFormatting(view, buttonAction, usingSpec);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function applyReactiveActionFormatting(_this__u8e3s4, action, usingSpec) {
  usingSpec = usingSpec === VOID ? true : usingSpec;
  applyReactiveFormatting(_this__u8e3s4, action, usingSpec, ($this$applyReactiveFormatting, it) => {
    _this__u8e3s4.obg(it);
    return Unit_instance;
  });
  var tmp = KMutableProperty0();
  var tmp_0 = Button$_get_enabled_$ref_61t7nx_0(_this__u8e3s4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp, tmp_0, Button$_set_enabled_$ref_o8kynz_0(_this__u8e3s4));
  reactiveScope(_this__u8e3s4, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj(action);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.dg1_1;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        tmp_0 = tmp0_safe_receiver_0($this$reactiveScope);
      }
      tmp = !(tmp_0 === false);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp$ret$3 = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    this_0.set(tmp$ret$3);
    return Unit_instance;
  });
}
function rviewFormatting$contents(_this__u8e3s4, $formatting, $usingSpec) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  var tmp = get_centered(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (IconView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  var $this$icon = view_0;
  $this$icon.gbu($formatting.i20());
  reactive($this$icon, ($this$reactive) => {
    var tmp0_safe_receiver = $formatting.ug0();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      tmp = tmp0_safe_receiver($this$reactive);
    }
    var icon = tmp;
    $this$icon.jb7(!(icon == null));
    $this$icon.sbt(icon);
    return Unit_instance;
  });
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_0 = view.kbb(!$usingSpec ? get_expanding(view) : Companion_getInstance(), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
  if (!$usingSpec && $formatting.ug0() == null) {
    view_1.dbs(Align_Center_getInstance());
  }
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_0(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    // Inline function 'kotlin.let' call
    var it = $formatting;
    var tmp0_safe_receiver = it.e90();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      tmp = tmp0_safe_receiver($this$reactiveScope);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp$ret$7 = tmp1_elvis_lhs == null ? it.i20() : tmp1_elvis_lhs;
    this_0.set(tmp$ret$7);
    return Unit_instance;
  });
  view.hbb(p_1, view_1);
  view.lbb(tmp_0, view_1);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function TextView$_get_align_$ref_7uii4p(p0) {
  return () => p0.vco_1;
}
function TextView$_set_align_$ref_lgby9v(p0) {
  return (_this__u8e3s4) => {
    p0.dbs(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  ButtonAction as ButtonActionqmmxsu493eh2,
  ButtonFormatting as ButtonFormatting3voagp9s33g1x,
  applyActionFormatting as applyActionFormatting3qxwpgmo0ne4m,
  applyFormatting as applyFormatting2iljszizgo9zk,
  applyReactiveActionFormatting as applyReactiveActionFormatting11beyf0tv05i4,
  button as button2ojurxuym14mn,
  mobileButtonRow as mobileButtonRow232s2tjlco685,
  Companion_instance as Companion_instance1hgjusdx1kcma,
};
//endregion

//# sourceMappingURL=ButtonAction.mjs.map
